<template>
  <!----生产预警--->
  <div class="container">
    <ul class="warning-list">
      <li class="warning-item">
        <Card
          title="证照过期"
          :totalNum="licenceTotalNum"
          imgName="note"
          :titleList="licenceTitleList"
          :briefList="licenceBriefList"
          @moreClick="handleClick('license')"
          @briefItemClick="briefItemClick"
          :cursor="true"
        />
      </li>
      <li class="warning-item">
        <Card
          bgImage="squre"
          title="原辅料异常"
          imgName="circle"
          :totalNum="rawAccessoryTotalNum"
          :titleList="rawAccessoryTitleList"
          :briefList="rawAccessoryBriefList"
          @moreClick="handleClick('material')"
          @briefItemClick="briefItemClick"
          :cursor="true"
        />
      </li>
      <li class="warning-item">
        <Card
          bgImage="rectangle"
          imgName="squre"
          title="生产存储异常"
          :totalNum="stockTotalNum"
          :titleList="stockTitleList"
          :briefList="stockBriefList"
          @moreClick="handleClick('production')"
          @briefItemClick="briefItemClick"
          :cursor="true"
        />
      </li>
      <li class="warning-item">
        <Card
          bgImage="triangle"
          imgName="home"
          title="进销存异常"
          :totalNum="saleTotalNum"
          :titleList="saleTitleList"
          :briefList="saleBriefList"
          @moreClick="handleClick('sell')"
          @briefItemClick="briefItemClick"
          :cursor="true"
        />
      </li>
    </ul>
    <waring-detail
      :warningId="warningId"
      :visible="visible"
      :closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import Card from 'components/card/card';
import WaringDetail from 'components/warning/detail';

export default {
  data() {
    return {
      licenceTotalNum: '',
      licenceTitleList: [],
      licenceBriefList: [],
      rawAccessoryTotalNum: '',
      rawAccessoryTitleList: [],
      rawAccessoryBriefList: [],
      stockTotalNum: '',
      stockTitleList: [],
      stockBriefList: [],
      saleTotalNum: '',
      saleTitleList: [],
      saleBriefList: [],
      visible: false,
      warningId: ''
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadLicenceWarning();
      this.loadRawAccessoryWarning();
      this.loadStockWaring();
      this.loadSaleWaring();
    },
    // 证照过期
    loadLicenceWarning() {
      this.$request({
        url: 'rest/riskwarning/produce/licenseOutdated',
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: 1, pageSize: 5 },
            params: {}
          })
        }
      }).then(res => {
        this.licenceTitleList = [
          {
            text: '营业执照临期',
            num: res.licenseNear
          },
          {
            text: '生产许可证临期',
            num: res.approvalNear
          },
          {
            text: '营业执照过期',
            num: res.license
          },
          {
            text: '生产许可证过期',
            num: res.approval
          }
        ];
        let total = 0;
        this.licenceTitleList.forEach(item => {
          total += parseInt(item.num);
        });
        this.licenceTotalNum = total + '';
        this.licenceBriefList = res.list.map(item => ({
          ...item,
          time: item.create_time,
          brief: item.msg
        }));
      });
    },
    // 原辅料异常
    loadRawAccessoryWarning() {
      this.$request({
        url: 'rest/riskwarning/produce/material',
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: 1, pageSize: 5 },
            params: {}
          })
        }
      }).then(res => {
        this.rawAccessoryTitleList = [
          {
            text: '原辅料检验缺失',
            num: res.materialReportMiss
          },
          {
            text: '原辅料过期',
            num: res.materialOutdated
          },
          {
            text: '非指定供应商',
            num: res.supplierNotMatch
          }
          // {
          //   text: '原辅料检验不合格',
          //   num: res.materialUnQuality
          // }
        ];
        let total = 0;
        this.rawAccessoryTitleList.forEach(item => {
          total += parseInt(item.num);
        });
        this.rawAccessoryTotalNum = total + '';
        this.rawAccessoryBriefList = res.list.map(item => ({
          ...item,
          time: item.create_time,
          brief: item.msg
        }));
      });
    },
    // 生产存储异常
    loadStockWaring() {
      this.$request({
        url: 'rest/riskwarning/produce/produceAndStore',
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: 1, pageSize: 5 },
            params: {}
          })
        }
      }).then(res => {
        this.stockTitleList = [
          {
            text: '成品检验缺失',
            num: res.produceReportMiss
          },
          {
            text: '温湿度异常',
            num: res.temperatureHumidity
          }
          // {
          //   text: '成品检验不合格',
          //   num: res.produceUnQuality
          // },
          // {
          //   text: '洁净度超限',
          //   num: res.cleanOverrun
          // }
        ];
        let total = 0;
        this.stockTitleList.forEach(item => {
          total += parseInt(item.num);
        });
        this.stockTotalNum = total + '';
        this.stockBriefList = res.list.map(item => ({
          ...item,
          time: item.create_time,
          brief: item.msg
        }));
      });
    },
    // 进销存异常
    loadSaleWaring() {
      this.$request({
        url: 'rest/riskwarning/produce/erpWarn',
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: 1, pageSize: 5 },
            params: {}
          })
        }
      }).then(res => {
        this.saleTitleList = [
          {
            text: '过效期销售',
            num: res.outdatedSale
          },
          {
            text: '过效期库存',
            num: res.outdatedStock
          },
          {
            text: '进销不平衡',
            num: res.erpUnbalance
          }
        ];
        let total = 0;
        this.saleTitleList.forEach(item => {
          total += parseInt(item.num);
        });
        this.saleTotalNum = total + '';
        this.saleBriefList = res.list.map(item => ({
          ...item,
          time: item.create_time,
          brief: item.msg
        }));
      });
    },
    handleClick(type) {
      this.$router.push({
        path: `/page/riskWarning/waringList/production/${type}`
      });
    },
    briefItemClick(item) {
      this.warningId = item.id;
      this.visible = true;
    },
    closeDialog() {
      this.visible = false;
    }
  },
  components: {
    Card,
    WaringDetail
  }
};
</script>

<style lang="stylus" scoped>
.warning-list
  overflow hidden
.warning-item
  float left
  margin-right 45px
  &:last-child
    margin-right 0
</style>
